export const signIn = (credentials) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        dispatch({ type: "LOGIN_SUCCESS" });
      })
      .catch((err) => {
        dispatch({ type: "LOGIN_ERROR", err });
      });
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: "SIGNOUT_SUCCESS" });
      });
  };
};

export const resetPassword = (credentials) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .sendPasswordResetEmail(credentials.email)
      .then(() => {
        dispatch({ type: "PASSWORD_RESET_SUCCESS" });
      })
      .catch((err) => {
        dispatch({ type: "PASSWORD_RESET_ERROR", err });
      });
  };
};

export const checkUserRole = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    // check if current user exists

    if (firebase.auth().currentUser) {
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          if (idTokenResult.claims.superAdmin) {
            dispatch({ type: "IS_SUPER_ADMIN" });
          } else {
            dispatch({ type: "NOT_SUPER_ADMIN" });
          }
        })
        .catch((error) => {});
    } else {
    }
  };
};
